exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._1hRD{display:block}", "", {"version":3,"sources":["/opt/build/repo/src/routes/bookyourstay/style.css"],"names":[],"mappings":"AAAA,OACI,aAAc,CACjB","file":"style.css","sourcesContent":[".container {\n    display:block;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "_1hRD"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/routes/bookyourstay/style.css
// module id = 504
// module chunks = 2 8